<template>
  <div class="sticky w-full bg-white border-r" id="main-nav">
    <div class="flex flex-nowrap items-center text-primary pl-4 pt-2 rounded-lg cursor-pointer absolute -left-8"
      @click="store.toggleSidebar()">
      <AlignJustify class="mr-2" />
    </div>
    <div class="mb-4 px-4 space-y-4">
      <RouterLink :to="{ name: 'workbook', params: {} }"
        class="flex flex-nowrap items-center text-primary h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/workbook' ? 'bg-secondary' : ''">
        <Home class="mr-2"></Home>
        <span class="text-gray-700 grow" v-if="sideBarOpen">Home</span>
      </RouterLink>
      <RouterLink to="/crisis-plan"
        class="flex flex-nowrap items-center text-primary h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/crisis-plan' ? 'bg-secondary' : ''">
        <BookHeart class="mr-2"></BookHeart>
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">My Crisis Plan</span>
      </RouterLink>
      <RouterLink :to="{ name: 'my-hope-kit', params: {} }"
        class="flex flex-nowrap items-center text-primary h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/my-hope-kit' ? 'bg-secondary' : ''">
        <BriefcaseMedical class="mr-2"></BriefcaseMedical>
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">My Hope Kit</span>
      </RouterLink>
      <RouterLink :to="{ name: 'completed-modules', params: {} }"
        class="flex flex-nowrap items-center text-primary h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer" :class="$router.currentRoute.value.fullPath === '/clinician/modules-to-review'
          ? 'bg-secondary'
          : ''
          ">
        <ListChecks class="mr-2"></ListChecks>
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">Completed Modules</span>
      </RouterLink>
      <RouterLink :to="{ name: 'notes', params: {} }"
        class="flex flex-nowrap items-center text-primary h-10 p-4 rounded-lg hover:bg-secondary cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/notes' ? 'bg-secondary' : ''">
        <NotebookPen class="mr-2"></NotebookPen>
        <span class="text-gray-700" v-if="sideBarOpen">My Notes</span>
      </RouterLink>
    </div>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useSidebarStore } from '../stores/sidebar' // adjust the path to your store
import { Home, NotebookPen, BriefcaseMedical, ListChecks, BookHeart, AlignJustify, SquareX } from 'lucide-vue-next'

const store = useSidebarStore();
const sideBarOpen = computed(() => store.sidebar)
</script>